<template>
    <div class="dashboard-card" :class="{ highlight }">
        <div class="card-header">
            <a-icon :type="icon" class="card-icon" />
            <h4 class="card-title">{{ title }}</h4>
        </div>
        <div class="card-content">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'DashboardCard',
    props: {
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        highlight: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped>
.dashboard-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    border: 2px solid transparent;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        transform: translateY(-2px);
    }

    &.highlight {
        border-color: #52c41a;
        background: linear-gradient(135deg, #ffffff 0%, #f6ffed 100%);
    }

    .card-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 16px;

        .card-icon {
            font-size: 24px;
            color: #1890ff;
        }

        .card-title {
            margin: 0;
            font-size: 14px;
            font-weight: 600;
            color: #595959;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
    }

    .card-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 60px;
    }
}
</style>
